import React from 'react';
import cn from 'classnames';
import inputStyles from './ModalInput.module.scss';

interface ModalInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const ModalInput: React.FC<ModalInputProps> = ({ children, className, style, ...props }) => (
  // eslint-disable-next-line react/void-dom-elements-no-children
  <input
    {...props}
    className={cn(inputStyles.wrapper, className)}
    style={style}
  >
    {children}
  </input>
);

interface ModalSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const ModalSelect: React.FC<ModalSelectProps> = ({ children, className, style, ...props }) => (
  <select
    {...props}
    className={cn(inputStyles.wrapper, className)}
    style={style}
  >
    {children}
  </select>
);

export default { ModalInput, ModalSelect };
